const initalState = null;

const importFileReducer = (state = initalState, action) => {
  const { type, data } = action;

  switch (type) {
    case "ADD_IMPORT_FILE":
      return data;

    default:
      return state;
  }
};

export { importFileReducer };
